import { apiFetch } from '../api';

export const getInstallationList = (payload) => {
  return apiFetch('/InstallationDetails/Search', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const getInstallationListById = (id) => {
  return apiFetch(`/InstallationDetails/GetById?id=${id}`);
};

export const addInstallation = (payload, modulesParams) => {
  return apiFetch(`/InstallationDetails/Write?modules=${modulesParams}`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const deleteInstallationAPI = (installationGUID) => {
  return apiFetch(`/InstallationDetails/Delete?id=${installationGUID}`, {
    method: 'POST'
  });
};
